import React, { ButtonHTMLAttributes } from 'react';
import { createUseStyles } from 'react-jss';
import clsx from 'clsx';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  color?: 'primary' | 'secondary' | 'danger' | 'success' | 'info' | 'black';
  size?: 'small' | 'medium' | 'large' | 'wide';
  rounded?: boolean;
  block?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  className,
  color = 'primary',
  size = 'medium',
  rounded,
  block,
  ...others
}) => {
  const classes = useStyles();
  return (
    <button
      className={clsx(
        'btn',
        classes.base,
        {
          [classes.primary]: color === 'primary',
          [classes.secondary]: color === 'secondary',
          [classes.small]: size === 'small',
          [classes.medium]: size === 'medium',
          [classes.large]: size === 'large',
          [classes.wide]: size === 'wide',
          [classes.rounded]: rounded,
          [classes.block]: block,
          'btn-danger': color === 'danger',
          'btn-info': color === 'info',
          'btn-success': color === 'success',
          'black': color === 'black'
        },
        className,
      )}
      {...others}
    />
  );
};

export const useStyles = createUseStyles({
  base: {
    padding: '5px 10px',
    textAlign: 'center',
    '&:active': {
      outline: 'none',
      boxShadow: 'none',
    },
    '&:focus': {
      outline: 'none',
      boxShadow: 'none',
    },
    '&:disabled': {
      cursor: 'auto',
    },
  },
  primary: {
    backgroundColor: '#522583',
    color: '#FFFFFF',
    border: 'none',
    '&:hover': {
      color: '#FFFFFF',
    },
  },
  secondary: {
    backgroundColor: 'transparent',
    color: '#522583',
    borderWidth: '2px',
    borderColor: '#522583',
    '&:hover': {
      color: '#522583',
    },
  },
  rounded: {
    borderRadius: '30px',
  },
  small: {
    padding: '5px 10px',
  },
  medium: {
    padding: '10px 20px',
  },
  large: {
    padding: '10px 30px',
  },
  wide: {
    padding: '10px 50px',
  },
  block: {
    width: '100%',
    display: 'block',
  }
});

export default Button;
